import PropTypes           from 'prop-types'
import BigNumber           from 'bignumber.js'
import React               from 'react'
import { Row, Col, Alert } from 'react-bootstrap'

import { Pagination }   from 'alto-react-components/lib/components'
import KreditRepository from 'alto-react-kredit/lib/models'

import TransactionTable from './table'
import                       './main.sass'

zero = new BigNumber(0)

numberIfPresent = (val, { negate = false } = {}) ->
  if val?
    number = new BigNumber(val)
    if negate then number.negated() else number
  else null

export default class TransactionHistory extends React.Component
  @contextTypes =
    backend: PropTypes.object

  constructor: (props, context) ->
    super(props, context)

    @state =
      page:         1
      transactions: null
      moneyBalance: new BigNumber(0)
      pointBalance: new BigNumber(0)

  render: ->
    if @state.transactions
      <div id="transaction-history">
        {@balances()}
        {@history()}
      </div>
    else
      <Row id="transaction-history">
        <Col xs={12}><Alert>Načítám seznam transakcí</Alert></Col>
      </Row>

  balances: ->
    <Row id="transaction-balances">
      <Col xs={6}>
        <div className="text-center">
          Peněžní zůstatek: {@state.moneyBalance.toFixed(2)}
        </div>
      </Col>

      <Col xs={6}>
        <div className="text-center">
          Bodový zůstatek: {@state.pointBalance.toFixed(2)}
        </div>
      </Col>
    </Row>

  history: ->
    <Row>
      <Col xs={12}>
        <TransactionTable transactions={@state.transactions} />
        {@pagination()}
      </Col>
    </Row>

  pagination: ->
    pagination = @state.transactions.pagination

    <div className="text-center">
      <Pagination
       totalPages={pagination.pageCount}
       currentPage={pagination.pageNumber}
       onChange={@changePage.bind(@)} />
    </div>

  changePage: (pageNumber) ->
    @setState(page: pageNumber, @loadTransactions.bind(@))

  componentWillMount: ->
    @loadTransactions()
    @loadBalances()

  loadTransactions: ->
    @__relation ?= KreditRepository.forBackend(@context.backend).transactions
      .with('billHeader', 'billHeader.items', 'billHeader.items.product')
      .orderBy('-transactedAt')

    @__relation
      .page(@state.page)
      .where('kind.in': ['POI', 'KC'])
      .then (transactions) => @setState({ transactions })

    # for some reason, this fails in production build on server
    # - when you access transaction.associations.billHeader.associations.items,
    #   the lass AssociationProxy has the items attribute, but the property is 'unreadable'
    # repository = KreditRepository.forBackend(@context.backend)
    # relation   = repository.transactions
    #   .with('billHeader', 'billHeader.items', 'billHeader.items.product')

    # @context.backend.requestWithAuth('GET', '/kredit/get_transactions', \
    #                                  qs: { page: @state.page, page_size: 20 })
    #   .then (response) => @setState(transactions: relation.deserializeMany(response))

  loadBalances: ->
    @context.backend.requestWithAuth('GET', '/kredit/get_balances').then ({ balances }) =>
      @setState
        pointBalance: numberIfPresent(balances.POI) or zero
        moneyBalance: numberIfPresent(balances.KC)  or zero
